export default function calculator(a, b) {
    return a + b
}



export function calculator(a, b) {
    return a + b
}

export function math(a, b) {
    return a - b
}







// function calc(a, b) {
//     return a + b
// }

// function m(a, b) {
//     return a - b
// }
// export default {calc, m}